import {
  AppRootElementBlueprint,
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { UploadIndicator } from './components/UploadIndicator';
import { rootRouteRef } from './routes';

const FolderIcon = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    fill="currentColor"
  >
    <path d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" />
  </svg>
);

export const page = PageBlueprint.make({
  params: {
    path: '/ad-ams',
    routeRef: rootRouteRef,
    title: 'AD AMS',
    icon: <FolderIcon />,
    loader: () => import('./components/AdAmsPage').then(m => <m.AdAmsPage />),
  },
});

// A package publish goes on while the user browses the rest of Sheriff.
export const uploadIndicator = AppRootElementBlueprint.make({
  name: 'upload-indicator',
  params: { element: <UploadIndicator /> },
});

export const adAmsPlugin = createFrontendPlugin({
  pluginId: 'ad-ams',
  extensions: [page, uploadIndicator],
  routes: {
    root: rootRouteRef,
  },
});
